import { 
    GET_INPATIENT_CLAIM_OPTIONS_SUCCESS, 
    GET_INPATIENT_CLAIM_OPTIONS_ERROR,
    GET_CLAIM_OPTIONS_SUCCESS,
    GET_CLAIM_OPTIONS_ERROR,
    SET_COMPANY_CLAIM_OPTIONS_SUCCESS,
    SET_CLAIMANT_CLAIM_OPTIONS_SUCCESS,
    SET_VISIT_DATE_CLAIM_OPTIONS_SUCCESS
} from '../actions';

const initialState = {
    inpatientClaimOptions: null,
    outpatientClaimOptions: null,
    companyId: null,
    claimantId: null,
    visitDate: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_CLAIM_OPTIONS_SUCCESS:
            return Object.assign({}, {...state}, {
                inpatientClaimOptions: action.payload.data.claimoptions.inpatientClaimConfig, 
                outpatientClaimOptions: action.payload.data.claimoptions.outpatientClaimConfig
            });
        
        case GET_CLAIM_OPTIONS_ERROR:
            return state;
        case GET_INPATIENT_CLAIM_OPTIONS_SUCCESS:
            return Object.assign({}, {...state}, {inpatientClaimOptions: action.payload.data});
        case GET_INPATIENT_CLAIM_OPTIONS_ERROR:
            return state;

        case SET_COMPANY_CLAIM_OPTIONS_SUCCESS:
            return Object.assign({}, {...state}, {companyId: action.companyId});
        case SET_CLAIMANT_CLAIM_OPTIONS_SUCCESS:
                return Object.assign({}, {...state}, {claimantId: action.claimantId});
        case SET_VISIT_DATE_CLAIM_OPTIONS_SUCCESS:
            return Object.assign({}, {...state}, {visitDate: action.visitDate});
        default:
            return state;
    }
}